import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessagePopConfig, MessagePopService } from './message-pop.service';

const DEFAULT_TIME_DELAY = 4000;

@Component({
  selector: 'app-message-pop',
  templateUrl: './message-pop.component.html',
  styleUrls: ['./message-pop.component.scss']
})
export class MessagePopComponent implements OnInit, OnDestroy {
  message: MessagePopConfig | null = null;
  private subscription?: Subscription;
  private hideTimeout: any;

  constructor(private messagePopService: MessagePopService) { }

  ngOnInit(): void {
    this.subscription = this.messagePopService.notifySubject.subscribe(
      (config: any) => this.show(config)
    );
  }

  show(config: MessagePopConfig) {
    clearTimeout(this.hideTimeout);
    this.message = config;
    this.hideTimeout = setTimeout(() => {
      this.message = null;
    }, config.timeDelay || DEFAULT_TIME_DELAY);
  }

  close() {
    clearTimeout(this.hideTimeout);
    this.message = null;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    clearTimeout(this.hideTimeout);
  }
}
